export default function autoFitColumns(
    rows,
    {
        minWidth = 10,
        maxWidth = 60,
        padding = 2,
        extraWidth = {}
    } = {}
) {

    if (!rows?.length) {
        return [];
    }

    const columns = Object.keys(rows[0]);

    return columns.map(column => {

        const values = [
            column,
            ...rows.map(row =>
                String(row[column] ?? '')
            )
        ];

        const maxLength = Math.max(
            ...values.map(value => value.length)
        );

        const extra =
            extraWidth[column] ?? 0;

        return {
            wch: Math.min(
                maxWidth,
                Math.max(
                    minWidth,
                    maxLength + padding + extra
                )
            )
        };

    });

}